import React from "react"

export default React.memo( ({ sentencia }) => (
    <tr>
      <th scope="row">
        <div className="d-flex align-items-center">
          <div className="mr-3">
            <img
              src={sentencia.foto}
              className="img-candidato rounded"
              alt={sentencia.candidato}
            />
          </div>
          <div className="">{sentencia.candidato}</div>
        </div>
      </th>
      <td className="text-left">{sentencia.region.toUpperCase()}</td>
      <td className="text-left">{sentencia.nro} {sentencia.partido.toUpperCase()}</td>
      <td className="text-left">{sentencia.delito}</td>
    </tr>
  ))